import React from "react";
import Typography from "@material-ui/core/Typography";
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { languages } from "../../constants/languages";
import TextField from "@material-ui/core/TextField";
import EditDayContainer from "../../containers/schedule/EditDayContainer";
import EditSportParkContainer from "../../containers/schedule/EditSportParkContainer";
import EditDivisionContainer from "../../containers/teams/EditDivisionContainer";
import ScoreCountContainer from "../../containers/structure/ScoreCountContainer";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import {
  Checkbox,
  FormControlLabel,
  Tooltip,
  IconButton,
} from "@material-ui/core";
import InfoIcon from "@material-ui/icons/Info";
import HelpIcon from "@material-ui/icons/Help";
import LanguageElement from "./LanguageElement";
import ColorsDivisions from "../../constants/colors_divisions";
import TournamentDetailsContainer from "../../containers/settings/TournamentDetailsContainer";

const styles = {
  textField: { marginBottom: 35 },
};

const General = (props) => (
  <div style={{ width: "100%", paddingTop: 20, paddingBottom: 50 }}>
    <div style={{ width: 650, maxWidth: "97%", margin: "auto" }}>
      <Typography variant="h6" style={{ marginBottom: 10 }}>
        {languages.general.nameTournament}
      </Typography>
      <TextField
        style={styles.textField}
        fullWidth
        // label={languages.general.nameTournament}
        name="name"
        value={props.tournament.name}
        onClick={props.toggleNameDialog}
      />
      <Typography style={{ marginBottom: 15 }} variant="h6">
        {languages.createTournament.matchDays}
      </Typography>
      <div style={{ marginBottom: 35, marginTop: 5 }}>
        <EditDayContainer
          tournament={props.tournament}
          day={{ date: props.tournament.date }}
          num={1}
          firstDay
          tournamentStatus={props.tournamentStatus}
          toggleFinishedDialog={props.toggleFinishedDialog}
        />
        {props.days
          .sort((a, b) => a.date - b.date)
          .map((day, i) => (
            <EditDayContainer
              key={i}
              tournament={props.tournament}
              day={day}
              matches={props.matches || []}
              num={i + 2}
              tournamentStatus={props.tournamentStatus}
              toggleFinishedDialog={props.toggleFinishedDialog}
            />
          ))}
        {!props.tournament.nvdCode && (
          <div style={{ marginTop: 5 }}>
            <EditDayContainer
              tournament={props.tournament}
              days={props.days.sort((a, b) => a.date - b.date)}
              tournamentStatus={props.tournamentStatus}
              toggleFinishedDialog={props.toggleFinishedDialog}
            />
          </div>
        )}
      </div>

      <Typography variant="h6" style={{ marginBottom: 15 }}>
        {languages.general.locations}
      </Typography>
      <div
        style={{
          marginTop: 5,
        }}
      >
        <DragDropContext onDragEnd={props.onDragEnd}>
          <Droppable droppableId="locationDrop">
            {(provided, snapshot) => {
              return (
                <div ref={provided.innerRef}>
                  {props.sportParks.map((sportPark, i) => (
                    <Draggable
                      key={sportPark.id}
                      draggableId={sportPark.id}
                      index={i}
                      isDragDisabled={props.tournament.online || false}
                    >
                      {(provided, snapshot) => (
                        <div>
                          <div
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                          >
                            <EditSportParkContainer
                              key={sportPark.id}
                              tournament={props.tournament}
                              sportPark={sportPark}
                              sportParks={props.sportParks}
                              num={i + 1}
                              isDisabled={props.tournament.online || false}
                              user={props.user}
                              userStatus={props.userStatus}
                              tournamentStatus={props.tournamentStatus}
                              toggleUpgradeDialog={props.toggleUpgradeDialog}
                            />
                          </div>
                          {provided.placeholder}
                        </div>
                      )}
                    </Draggable>
                  ))}
                  {provided.placeholder}
                </div>
              );
            }}
          </Droppable>
        </DragDropContext>
      </div>
      <div style={{ marginBottom: 35, marginTop: 5 }}>
        <EditSportParkContainer
          tournament={props.tournament}
          sportParks={props.sportParks}
          isDisabled={props.tournament.online || false}
          user={props.user}
          userStatus={props.userStatus}
          tournamentStatus={props.tournamentStatus}
          toggleUpgradeDialog={props.toggleUpgradeDialog}
        />
        {!props.tournament.isSporta && (
          <div style={{ display: "flex", alignItems: "center", marginTop: 15 }}>
            <FormControlLabel
              disabled={
                props.tournamentStatus.status > 0 || props.tournament.isPSD
              }
              style={{ marginRight: 0 }}
              control={
                <Checkbox
                  checked={props.tournament.online || false}
                  onChange={props.handleOnlineCheck}
                  color="primary"
                />
              }
              label={languages.tournament.online}
            />
            <Tooltip
              title={languages.tournament.onlineDescription}
              placement="top"
            >
              <span>
                <IconButton
                  disabled
                  style={{
                    paddingLeft: 0,
                    paddingRight: 0,
                  }}
                >
                  <HelpIcon
                    style={{
                      height: 17,
                      marginLeft: 5,
                    }}
                  />
                </IconButton>
              </span>
            </Tooltip>
            {props.tournamentStatus.status > 0 && (
              <Tooltip
                title={languages.tournament.onlineLocked}
                placement="top"
              >
                <span>
                  <IconButton
                    disabled
                    style={{
                      paddingLeft: 0,
                      paddingRight: 0,
                    }}
                  >
                    <InfoIcon
                      style={{
                        height: 17,
                      }}
                    />
                  </IconButton>
                </span>
              </Tooltip>
            )}
          </div>
        )}
      </div>

      <Typography variant="h6" style={{ marginBottom: 15 }}>
        {languages.divisions.divisions}
      </Typography>
      <div style={{ marginBottom: 35, marginTop: 5 }}>
        <DragDropContext onDragEnd={props.onDragEndDivision}>
          <Droppable droppableId="divisionDrop">
            {(provided, snapshot) => {
              return (
                <div ref={provided.innerRef}>
                  {props.divisions
                    .sort((a, b) => {
                      if (a.num > b.num) {
                        return 1;
                      } else if (a.num < b.num) {
                        return -1;
                      }
                      if (a.id > b.id) {
                        return 1;
                      } else if (a.id < b.id) {
                        return -1;
                      } else {
                        return 0;
                      }
                    })
                    .map((division, i) => (
                      <Draggable
                        key={division.id}
                        draggableId={division.id}
                        index={i}
                      >
                        {(provided, snapshot) => (
                          <div>
                            <div
                              ref={provided.innerRef}
                              {...provided.draggableProps}
                              {...provided.dragHandleProps}
                            >
                              <EditDivisionContainer
                                key={division.id}
                                tournament={props.tournament}
                                division={division}
                                num={i + 1}
                                user={props.user}
                                userStatus={props.userStatus}
                                tournamentStatus={props.tournamentStatus}
                                toggleUpgradeDialog={props.toggleUpgradeDialog}
                                toggleFinishedDialog={
                                  props.toggleFinishedDialog
                                }
                                color={ColorsDivisions[i % 25]}
                              />
                            </div>
                            {provided.placeholder}
                          </div>
                        )}
                      </Draggable>
                    ))}
                  {provided.placeholder}
                </div>
              );
            }}
          </Droppable>
        </DragDropContext>
        <div style={{ marginTop: 5 }}>
          <EditDivisionContainer
            tournament={props.tournament}
            user={props.user}
            userStatus={props.userStatus}
            tournamentStatus={props.tournamentStatus}
            toggleUpgradeDialog={props.toggleUpgradeDialog}
            toggleFinishedDialog={props.toggleFinishedDialog}
          />
        </div>
      </div>
      <div>
        <Typography style={{ marginBottom: 15 }} variant="h6">
          {languages.general.language}
        </Typography>
        <div
          style={{
            marginBottom: 20,
            marginTop: 5,
            display: "flex",
            alignItems: "center",
          }}
        >
          {(props.tournament.lang || []).map((lang, i) => {
            return (
              <LanguageElement
                key={i}
                index={i}
                lang={lang}
                tournament={props.tournament}
                tournamentLang={props.tournament.lang || []}
              />
            );
          })}
          <LanguageElement
            tournament={props.tournament}
            tournamentLang={props.tournament.lang || []}
          />
        </div>
        <Typography
          variant="body2"
          style={{
            background: "rgb(236, 239, 241)",
            padding: 10,
            borderRadius: 5,
            marginBottom: 35,
          }}
        >
          <InfoIcon
            style={{ height: 15, width: 15, top: 2, position: "relative" }}
          />
          {" " + languages.general.languagesDescription}
        </Typography>
      </div>

      {/* Tournament details */}
      <div style={{ flexGrow: 1, marginBottom: 15 }}>
        <ExpansionPanel style={{ boxShadow: "none" }}>
          <ExpansionPanelSummary
            style={{ paddingLeft: 0, paddingRight: 0 }}
            expandIcon={<ExpandMoreIcon />}
          >
            <div style={{ display: "block" }}>
              <Typography variant="h6">
                {languages.general.native.tournamentDetails}
              </Typography>
              <Typography variant="caption">
                {languages.general.native.tournamentDetailsDescription}
              </Typography>
            </div>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails style={{ paddingLeft: 0, paddingRight: 0 }}>
            <div style={{ width: "100%" }}>
              <TournamentDetailsContainer tournament={props.tournament} />
              {/* <Typography
                variant="body2"
                style={{
                  background: "rgb(236, 239, 241)",
                  padding: 10,
                  borderRadius: 5,
                }}
              >
                <InfoIcon
                  style={{
                    height: 15,
                    width: 15,
                    top: 2,
                    position: "relative",
                  }}
                />
                {" " + languages.general.native.tournamentDetailsHint}
              </Typography> */}
            </div>
          </ExpansionPanelDetails>
        </ExpansionPanel>
      </div>
      <ScoreCountContainer tournament={props.tournament} />
    </div>
  </div>
);

export default General;
